import Icon from '../components/Icon.vue'

Icon.register({
  coffee: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M192 384c-53 0-96-43-96-96v-232c0-13.3 10.7-24 24-24h392c70.6 0 128 57.4 128 128s-57.4 128-128 128h-32c0 53-43 96-96 96h-192zM512 96h-32v128h32c35.3 0 64-28.7 64-64s-28.7-64-64-64zM559.7 480h-511.4c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/coffee.js
// module id = 1221
// module chunks = 0